<template>
    <div>
        <div class="w-full h-auto">
            <vs-chip class="mb-4" transparent :color="statusColor">{{statusText}}</vs-chip>
        </div>
        <template v-if="item.status === 1 || item.status === 2 && item.responsible_person.user.profile.profileId !== user.profileId">
            <vs-divider class="mb-3 mt-3"></vs-divider>
            <div class="w-full">
                <vs-button @click="addWork()" class="take_to_work" color="primary" type="filled">{{$t('take_to_work')}}</vs-button>
            </div>
        </template>
        <template v-if="item.status === 2 && item.responsible_person.user.profile.profileId === user.profileId">
            <vs-divider class="mb-3 mt-3"></vs-divider>
            <div class="w-full">
                <vs-button @click="closeWork()" class="bug_complete" color="success" type="filled">{{$t('complete')}}</vs-button>
            </div>
        </template>
        <vs-divider class="mb-3 mt-3"></vs-divider>
        <div>
            <span class="pr-2">{{$t('author')}}</span> {{userName}}
        </div>
        <template v-if="item.responsible_person && item.responsible_person.user">
            <vs-divider class="mb-3 mt-3"></vs-divider>
            <div>
                <span class="pr-2">{{$t('responsible')}}</span>
                <template v-if="item.responsible_person.user.profile.profileId === user.profileId">
                    <span class="text-danger">{{$t('you')}}</span>
                </template>
                <template v-else>
                    {{userName2}}
                </template>
            </div>
        </template>
        <vs-divider class="mb-3 mt-3"></vs-divider>
        <div v-if="item.text">
            <label class="text-sm mb-1">{{$t('description')}}:</label>
            <div v-html="item.text"></div>
        </div>
        <vs-divider class="mb-3 mt-3"></vs-divider>
        <div>
            <span>{{$t('page_url')}}:</span> <a target="_blank" :href="item.url">{{item.url}}</a>
        </div>
        <vs-divider v-if="item.attachments.length" class="mb-3 mt-3"></vs-divider>
        <div v-if="item.attachments.length">
            <label class="text-sm mb-1">{{$t('files')}}:</label>
            <div class="file_bugs_item" v-for="(file, index) in item.attachments" :key="index">
                <template v-if="file.extension === 'png' || file.extension === 'gif' || file.extension === 'jpg' || file.extension === 'jpeg'">
                    <a target="_blank" :href="file.path">
                        <img :src="file.path" />
                    </a>
                </template>
                <template v-else>
                    <a download :href="file.path">{{$t('down_file')}}</a>
                </template>
            </div>
        </div>
        <vs-divider class="mb-3 mt-3"></vs-divider>
        <div>
            <span>{{$t('created')}}:</span> {{dateReplace}}
        </div>
        <vs-divider class="mb-3 mt-3"></vs-divider>
        <div>
            <span>{{$t('updated')}}:</span> {{dateUpdate}}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        async closeWork() {
            try {
                this.$vs.loading({
                    container: '.bug_complete',
                    scale: 0.6
                })
                const {data} = await this.$http.post('/bugtracker/complete/', {uid: this.item.uid})
                if(data === 'ok') {
                    this.$store.commit('bug_list/UPDATE_BUG', {item: this.item, status: 3, user: this.user})
                    this.$vs.notify({
                        text: this.$t('bug_fixed'),
                        color: 'success'
                    })

                    const elem = document.querySelector('.pyro')
                    if(elem) {
                        elem.classList.add('show')
                        setTimeout(() => {
                            elem.classList.remove('show')
                        }, 3000)
                    }
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('.bug_complete > .con-vs-loading')
            }
        },
        async addWork() {
            try {
                this.$vs.loading({
                    container: '.take_to_work',
                    scale: 0.6
                })
                const {data} = await this.$http.post('/bugtracker/take/', {uid: this.item.uid})
                if(data === 'ok') {
                    this.$store.commit('bug_list/UPDATE_BUG', {item: this.item, status: 2, user: this.user})
                    this.$vs.notify({
                        text: this.$t('bug_in_work'),
                        color: 'success'
                    })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('.take_to_work > .con-vs-loading')
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user.user
        },
        dateReplace() {
            // Меняем формат даты
            return this.$moment(this.item.created).format('DD MM YYYY H:mm')
        },
        dateUpdate() {
            // Меняем формат даты
            return this.$moment(this.item.updated).format('DD MM YYYY H:mm')
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if(this.$i18n.locale === 'en') {
                // Если имя на англ пустое, используем рус имя
                if(this.item.author.profile.first_name_en)
                    return `${ this.item.author.profile.last_name_en } ${ this.item.author.profile.first_name_en }`
                else
                    return `${ this.item.author.profile.lastName } ${ this.item.author.profile.firstName } ${ this.item.author.profile.middleName }`
            } else
                return `${ this.item.author.profile.lastName } ${ this.item.author.profile.firstName } ${ this.item.author.profile.middleName }`
        },
        userName2() {
            // Если текущий язык английский, подставляем имя на англ
            if(this.$i18n.locale === 'en') {
                // Если имя на англ пустое, используем рус имя
                if(this.item.responsible_person.user.profile.first_name_en)
                    return `${ this.item.responsible_person.user.profile.last_name_en } ${ this.item.responsible_person.user.profile.first_name_en }`
                else
                    return `${ this.item.responsible_person.user.profile.lastName } ${ this.item.responsible_person.user.profile.firstName } ${ this.item.responsible_person.user.profile.middleName }`
            } else
                return `${ this.item.responsible_person.user.profile.lastName } ${ this.item.responsible_person.user.profile.firstName } ${ this.item.responsible_person.user.profile.middleName }`
        },
        statusText() {
            switch (this.item.status) {
            case 1:
                return this.$t('new_bug')
                break;
            case 2:
                return this.$t('in_work')
                break;
            case 3:
                return this.$t('performed')
                break;
            }
        },
        statusColor() {
            switch (this.item.status) {
            case 1:
                return 'primary'
                break;
            case 2:
                return 'warning'
                break;
            case 3:
                return 'success'
                break;
            }
        }
    }
}
</script>

<style lang="scss">
.bug_complete,
.take_to_work{
    position: relative;
    .con-vs-loading{
        position: absolute;
        background: transparent;
    }
}
</style>

<style lang="scss" scoped>
.file_bugs_item{
    &:not(:last-child){
        margin-bottom: 10px;
    }
    img{
        max-width: 100%;
        border: 1px solid #cccccc;
    }
}
</style>
